import {FC, useContext, useEffect, useState} from "react";
import Table from "../../ui/Table";
import {FaPen, FaTrash} from "react-icons/fa";
import {IUnit} from "../../../types/ApiTypes";
import {AppContext} from "../../../context/AppContext";

interface Props {
    units: {
        main: IUnit[],
        secondary: IUnit[],
    }
    editSelected: (id: number) => void;
    deleteSelected: (id: number) => void;
}

const UnitsList: FC<Props> = (props) => {
    const {state: {user}} = useContext(AppContext);
    const [units, setUnits] = useState<IUnit[]>([]);

    useEffect(() => {
        setUnits(props.units.main.concat(props.units.secondary));
    },[props.units])

    const getOwner = (id: string) => {
        return user?.find(x => x.id === id)?.displayName || 'Unbekannt - '+id;
    }

    const onEditSelected = (id: number) => {
        props.editSelected(id);
    }

    const onDeleteSelected = (id: number) => {
        props.deleteSelected(id);
    }

    return (
        <Table.Skeleton>
            <Table.THead>
                <Table.HeadTR>
                    <Table.TH>Name</Table.TH>
                    <Table.TH>Parent Unit</Table.TH>
                    <Table.TH>Owner</Table.TH>
                    <Table.TH/>
                </Table.HeadTR>
            </Table.THead>
            <Table.TBody>
                {units.length > 0 ? (
                    units.map(x => (
                        <Table.BodyTR key={x.id}>
                            <Table.TD>{x.name}</Table.TD>
                            <Table.TD>{x.parent_unit ? x.parent_unit.name : '-'}</Table.TD>
                            <Table.TD>{getOwner(x.owner)}</Table.TD>
                            <Table.TD className='flex justify-between items-center'>
                                <div className='flex gap-2'>
                                    <FaTrash className='cursor-pointer text-error-brighter' onClick={() => onDeleteSelected(x.id)}/>
                                    <FaPen className='cursor-pointer' onClick={() => onEditSelected(x.id)}/>
                                </div>
                            </Table.TD>
                        </Table.BodyTR>
                    ))
                ) : (
                    <Table.BodyTR>
                        <Table.TD colspan={4}>Keine Bereiche verfügbar</Table.TD>
                    </Table.BodyTR>
                )}
            </Table.TBody>
        </Table.Skeleton>
    );
};

export default UnitsList;